// extracted by mini-css-extract-plugin
export default {"dataWeather":"DataWeather_dataWeather__Etyuj"};